<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img :src="imgUrl" fluid alt="Register V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset password-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <!-- Content when token is valid -->
          <div v-if="!tokenExpired">
            <b-card-title title-tag="h2" class="font-weight-bold mb-1">
              Resetar Senha 🔒
            </b-card-title>
            <b-card-text class="mb-2">
              Insira sua nova senha
            </b-card-text>

            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form class="auth-reset-password-form mt-2" method="POST" @submit.prevent="validationForm">

                <!-- password -->
                <b-form-group label="Nova Senha" label-for="reset-password-new">
                  <validation-provider #default="{ errors }" name="Password" vid="Password" rules="required">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                      <b-form-input id="reset-password-new" v-model="password" :type="password1FieldType"
                        :state="errors.length > 0 ? false : null" class="form-control-merge" name="reset-password-new"
                        placeholder="············" />
                      <b-input-group-append is-text>
                        <feather-icon class="cursor-pointer" :icon="password1ToggleIcon"
                          @click="togglePassword1Visibility" />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Confirmar Senha -->
                <b-form-group label-for="reset-password-confirm" label="Confirmar Senha">
                  <validation-provider #default="{ errors }" name="Confirmar Senha" rules="required|confirmed:Password">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                      <b-form-input id="reset-password-confirm" v-model="cPassword" :type="password2FieldType"
                        class="form-control-merge" :state="errors.length > 0 ? false : null" name="reset-password-confirm"
                        placeholder="············" />
                      <b-input-group-append is-text>
                        <feather-icon class="cursor-pointer" :icon="password2ToggleIcon"
                          @click="togglePassword2Visibility" />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit button -->
                <b-button block type="submit" variant="primary" :disabled="isSubmitting">
                  <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
                  {{ isSubmitting ? 'Processando...' : 'Definir Nova Senha' }}
                </b-button>
              </b-form>
            </validation-observer>
          </div>

          <!-- Content when token is expired -->
          <div v-else class="text-center">
            <div class="mb-4">
              <feather-icon size="50" icon="AlertTriangleIcon" class="text-warning" />
            </div>
            <b-card-title title-tag="h2" class="font-weight-bold mb-1">
              Link Expirado
            </b-card-title>
            <b-card-text class="mb-4">
              O link de redefinição de senha expirou ou é inválido. Tente novamente.
            </b-card-text>
          </div>

          <p class="text-center mt-4">
            <b-link :to="{ name: 'login' }">
              <feather-icon icon="ChevronLeftIcon" /> Voltar para login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VuexyLogo from '@core/layouts/components/Logo.vue';
import {
  BRow, BCol, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend,
  BLink, BFormInput, BButton, BImg, BSpinner,
} from 'bootstrap-vue';
import { required } from '@validations';
import store from '@/store/index';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import router from '@/router';
import { useApi } from '@/composables/useApi';
import Notifier from '@/libs/Notifier';
import axios from '@/libs/axios';

const notify = new Notifier();

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BImg,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      token: this.$route.params.token,
      email: decodeURIComponent(this.$route.params.id),
      cPassword: '',
      password: '',
      isSubmitting: false,
      tokenExpired: false,
      sideImg: require('@/assets/images/pages/reset-password-v2.svg'),
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/reset-password-v2-dark.svg');
        return this.sideImg;
      }
      return this.sideImg;
    },
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
  },
  created() {
    // Validate token when component is created
    this.validarToken();
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password';
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password';
    },
    async validarToken() {
      try {
        // Call API to validate token
        const response = await axios.post('/seguranca/validarToken', {
          token: this.token,
          email: this.email,
        });

        // If API returns a flag indicating token status
        this.tokenExpired = !response.data.valid;
      } catch (error) {
        console.error('Erro ao validar token:', error.response || error);
        // If there's an error, we assume the token is invalid/expired
        this.tokenExpired = true;
      }
    },
    async mudarSenha() {
      this.isSubmitting = true;

      try {
        await axios.post('/seguranca/resetSenha', {
          token: this.token,
          email: this.email,
          novaSenha: this.password,
          confirmacaoNovaSenha: this.cPassword,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Senha alterada com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });

        localStorage.removeItem('verifyEmail');

        setTimeout(() => {
          this.$router.push({ name: 'login' });
        }, 1500);
      } catch (error) {
        console.error('Erro ao redefinir senha:', error.response || error);

        // Check if token expired error
        if (error.response?.data?.code === 'TOKEN_EXPIRED') {
          this.tokenExpired = true;
        } else {
          const errorMessage = error.response?.data?.message || 'Erro ao redefinir a senha. Tente novamente.';

          this.$toast({
            component: ToastificationContent,
            props: {
              title: errorMessage,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.mudarSenha();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
